import React from 'react';
import SesionService from "../../Services/Sesion.Service";
import Spinner from '../../components/Spinner';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            messageSpinner: "Espere un momento...",
            clave: "",
            error : ""
        }
    }


    // Functions
    getData = async () => {
        this.setState({ loading: true });

        //Obtener la sesion programada a partir del codigo

        await SesionService.getSesionProgramadaByKeyUri(this.state.clave)
            .then(response => {
                console.log(response);
                if (response.status === 200) {
                    let data = response.data;
                    //console.log(data);
                    if (data != null) {
                        var url = data.data.tokenUrl;
                        //console.log(url);
                        let tokenString = url.substring(url.lastIndexOf("/") + 1);
                        if (tokenString != null) {
                            console.log(tokenString)
                            this.props.history.push("/home/" + tokenString);
                        }
                        else {
                            this.setState({
                                error: "Sesión inactiva"
                            });
                        }
                    }
                    else {
                        this.setState({
                            error: "Sesión incorrecta"
                        });
                    }
                }
                else {
                    this.setState({
                        error: "Sesión incorrecta"
                    });
                }
            })
            .catch(e => {
                console.log(e);
                this.setState({
                    loading: false,
                    error: "Sesión incorrecta"
                });
            });
            
        this.setState({
            loading: false
        });
    }



    // Handlers
    //Input Text
    handlerChangeClave = async (value) => {
        this.setState(prevState => ({
            ...prevState,
            clave: value
        }));
    }
    //Button
    Unirse = async ()   => {
        let clave = this.state.clave;
        //Ir al servicio para obtener el Token de la sesion
        await this.getData();
        console.log(clave);
        //Redireccionar la sesión

        
    }

    componentDidMount = async () => {
    }


    render() {
        return (
            <><div className="page-container">
                <Spinner show={this.state.loading} message={this.state.messageSpinner} />
                <div className="title"><h1>ABP</h1></div>
                <div className="subtitle" style={{ marginTop: "45px", marginBottom:"45px" }}><p>Ingrese el código la sesión para unirse</p></div>
                <div className="subtitle">
                    <input maxLength="10" placeholder="Código de la sesión" value={this.state.clave} onChange={(e) => { this.handlerChangeClave(e.currentTarget.value) }} />
                </div> 
                <span className="error">
                    {this.state.error || ""}
                </span>
                <button onClick={() => { this.Unirse() }} className="btn primary" type="button">Unirme</button>
                
            </div></>
        )
    }
}
export default Home;